<template>
  <div id="contact-form">
    <div class="contact-wrapper">
      <!-- Left: Form Panel -->
      <div class="contact-panel">
        <div class="d-flex justify-content-start align-items-start mb-4" @click="close()">
          <div class="back-button d-flex align-items-center justify-content-center">
            <img src="../images/arrow-left-small.svg" alt="Back" style="width: 23px; height: 17.5px;" />
          </div>
        </div>

        <h1 class="merriweather-reg-40 contact-title">Contactez-nous</h1>
        <p class="raleway-reg-p15 contact-subtitle">Une question, une réclamation, besoin d'aide ? Pour toute information complémentaire, envoyez-nous un message.</p>

        <div class="contact-info">
          <p class="raleway-reg-p15 contact-info-line">
            WhatsApp : <a href="https://wa.me/33626203846" target="_blank" rel="noopener noreferrer" class="contact-link">+33 6 26 20 38 46</a>
          </p>
          <p class="raleway-reg-p15 contact-info-line">
            Via le formulaire ci-dessous :
          </p>
        </div>

        <form id="my-form-contact" action="https://formspree.io/f/xayvjvey" method="POST">
          <div class="form-row-double">
            <div class="form-field">
              <label class="raleway-reg-p15 field-label">Votre prénom</label>
              <input
                type="text"
                name="Prenom"
                class="form-control raleway-reg-p13 contact-input"
                placeholder="Camille"
                id="firstname"
              />
            </div>
            <div class="form-field">
              <label class="raleway-reg-p15 field-label">Votre nom</label>
              <input
                type="text"
                name="NOM"
                class="form-control raleway-reg-p13 contact-input"
                placeholder="Dupont"
                id="lastname"
              />
            </div>
          </div>

          <div class="form-row-double">
            <div class="form-field">
              <label class="raleway-reg-p15 field-label">Votre e-mail</label>
              <input
                type="email"
                name="Email"
                class="form-control raleway-reg-p13 contact-input"
                placeholder="camille@dupont.com"
                id="email"
              />
            </div>
            <div class="form-field">
              <label class="raleway-reg-p15 field-label">Numéro de téléphone</label>
              <input
                type="tel"
                name="Numero_de_telephone"
                class="form-control raleway-reg-p13 contact-input"
                placeholder="+33 6 12 34 56 78"
                id="phone"
              />
            </div>
          </div>

          <div class="form-row-double">
            <div class="form-field">
              <label class="raleway-reg-p15 field-label">Objet</label>
              <v-select
                class="select-item raleway-reg-p13 contact-select"
                placeholder="Choisir un objet"
                v-model="objectSelected"
                :options="objectChoices"
              ></v-select>
              <p v-if="showReservationHint" class="raleway-reg-p13 contact-object-hint">
                Merci de nous indiquer impérativement votre numéro de réservation ainsi que le nom de l'établissement concerné.
              </p>
              <p v-if="showAccommodationHint" class="raleway-reg-p13 contact-object-hint">
                Merci de nous indiquer le nom de l'hébergement qui a retenu votre attention.
              </p>
              <input type="hidden" name="Objet" :value="objectSelected || ''" />
            </div>
          </div>

          <div class="form-field form-field-full">
            <label class="raleway-reg-p15 field-label">Message</label>
            <textarea
              name="Message"
              class="form-control raleway-reg-p13 contact-textarea"
              placeholder="Votre message ..."
              id="message"
              rows="5"
            ></textarea>
          </div>

          <button type="submit" class="hortense-btn-primary contact-submit" id="my-form-contact-button">
            Envoyer ma demande
          </button>
          <p id="my-form-contact-status" class="raleway-reg-p13 form-status"></p>
          <p class="join-selection-note raleway-reg-p15">
            Si vous souhaitez rejoindre notre sélection,
            <a href="/devenir-hote" class="join-selection-link">contactez-nous ici</a>
          </p>
        </form>
      </div>

      <!-- Right: Image Panel -->
      <div class="contact-image-panel">
        <img
          src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/hortense-green-nous-contacter.webp"
          alt="Hortense - Nous contacter"
          class="contact-image"
        />
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    name: 'contact-form',

    data() {
      return {
        objectChoices: [
          "Question sur mon séjour",
          "Question sur un hébergement",
          "Question sur mon compte client",
          "Question pour devenir hôte",
          "Réclamation",
          "Autre"
        ],
        objectSelected: null,
      }
    },
    computed: {
      showReservationHint() {
        return this.objectSelected === "Question sur mon séjour";
      },
      showAccommodationHint() {
        return this.objectSelected === "Question sur un hébergement";
      },
    },
    methods: {
      submit() {
        const form = document.getElementById("my-form-contact");
        async function handleSubmit(event) {
          event.preventDefault();
          const status = document.getElementById("my-form-contact-status");
          const data = new FormData(event.target);
          fetch(event.target.action, {
            method: form.method,
            body: data,
            headers: {
              'Accept': 'application/json'
            }
          }).then(response => {
            status.innerHTML = "Votre message a bien été envoyé, nous vous en remercions. Nous vous recontacterons dans un délai de 24h ouvrées.";
            form.reset();
          }).catch(error => {
            status.innerHTML = "Oops! There was a problem submitting your form";
          });
        }
        form.addEventListener("submit", handleSubmit);
      },
      close() {
        window.history.back();
      },
    },
  }
</script>


<style lang="scss" scope='app/assets/stylesheets/components/contact-form'>
</style>

<style scoped>
  #contact-form {
    background-color: #f5f2ee;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
  }

  .contact-wrapper {
    display: flex;
    flex-direction: row;
    background: #ffffff;
    border-radius: 4px;
    overflow: hidden;
    max-width: 1100px;
    width: 100%;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
  }

  /* Left panel */
  .contact-panel {
    flex: 1 1 55%;
    padding: 48px 48px 48px 48px;
    display: flex;
    flex-direction: column;
  }

  .back-button {
    width: 40px;
    height: 38px;
    border-radius: 5px;
    background: #00000029;
    cursor: pointer;
    flex-shrink: 0;
  }

  .contact-title {
    margin-top: 8px;
    margin-bottom: 16px;
    color: #3b3b3b;
  }

  .contact-subtitle {
    color: #5a5a5a;
    margin-bottom: 24px;
    line-height: 1.6;
  }

  .contact-info {
    margin-bottom: 24px;
  }

  .contact-info-line {
    margin-bottom: 8px;
    color: #3b3b3b;
  }

  .contact-link {
    color: #b5924c;
    text-decoration: underline;

    &:hover {
      color: #9a7a3a;
    }
  }

  /* Form layout */
  .form-row-double {
    display: flex;
    gap: 16px;
    margin-bottom: 20px;
  }

  .form-field {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .form-field-full {
    margin-bottom: 24px;
  }

  .field-label {
    margin-bottom: 6px;
    color: #3b3b3b;
    font-weight: 600;
  }

  .contact-input {
    border: 1px solid #d0d0d0;
    border-radius: 3px;
    padding: 10px 14px;
    font-size: 13px;
    color: #3b3b3b;
    background: #ffffff;
    outline: none;
    transition: border-color 0.2s;

    &::placeholder {
      color: #b0b0b0;
    }

    &:focus {
      border-color: #b5924c;
      box-shadow: none;
    }
  }

  .contact-select {
    border-radius: 3px;
    background: #ffffff;
  }

  .contact-object-hint {
    margin-top: 8px;
    margin-bottom: 0;
    color: #D56A70;
    line-height: 1.4;
  }

  .contact-textarea {
    border: 1px solid #d0d0d0;
    border-radius: 3px;
    padding: 10px 14px;
    font-size: 13px;
    color: #3b3b3b;
    background: #ffffff;
    resize: vertical;
    min-height: 120px;
    outline: none;
    transition: border-color 0.2s;

    &::placeholder {
      color: #b0b0b0;
    }

    &:focus {
      border-color: #b5924c;
      box-shadow: none;
    }
  }

  .contact-submit {
    width: 100% !important;
    border: none;
    cursor: pointer;
    letter-spacing: 0.5px;
  }

  .form-status {
    margin-top: 12px;
    color: #5a5a5a;
    text-align: center;
  }

  /* Right image panel */
  .contact-image-panel {
    flex: 0 0 38%;
    min-height: 500px;
    overflow: hidden;
  }

  .contact-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  /* Mobile responsive */
  @media (max-width: 768px) {
    #contact-form {
      padding: 20px 12px;
      align-items: flex-start;
    }

    .contact-wrapper {
      flex-direction: column;
    }

    .contact-panel {
      padding: 45px 20px;
      flex: none;
    }

    .contact-title {
      font-size: 28px;
    }

    .form-row-double {
      flex-direction: column;
      gap: 0;
      margin-bottom: 0;
    }

    .form-field {
      margin-bottom: 16px;
    }

    .contact-image-panel {
      flex: none;
      width: 100%;
      min-height: 220px;
      max-height: 280px;
      order: 1;
    }

    .contact-panel {
      order: 0;
    }
  }

  /* Extra small mobile (319 x 375) */
  @media (max-width: 375px) {
    #contact-form {
      padding: 12px 8px;
    }

    .contact-panel {
      padding: 20px 16px;
    }

    .contact-title {
      font-size: 24px;
    }

    .contact-image-panel {
      min-height: 180px;
      max-height: 220px;
    }
  }
  .join-selection-note {
  margin: .25rem 0 0;
  text-align: center;
}
.join-selection-link {
  text-decoration: underline;
  color: #2f5a4d;
}
</style>
